import React from "react";
import Label from "../ui-components/Label";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";
import getOptionName from "../utils/getOptionName";
import MoveBlock from "./MoveBlock";
import SpreadsheetQuestionRangeModal from "./SpreadsheetQuestionRangeModal";


const ServiceConfiguratorBlockSpreadsheetInputMapping = ({
  spreadsheetConfigurationObject,
  updateSpreadsheetConfiguration,
  questions,
  recursiveQuestions,
  editable=true,
  ...rest
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(null);
  return (
    <div className="flex w-full flex-col mb-4">
      <Label>input mapping</Label>
      <div className="mb-2" />
      {Object.keys(spreadsheetConfigurationObject.input_mapping).map((questionId) => {
        return (
          <div
            key={questionId}
            className={`flex w-full justify-between items-center rounded border border-gray mt-2 mb-2 p-1.5`}
          >
            <div className="flex items-center">
              <div>
                <p>{questions.find((q)=>q.id===parseInt(questionId)).name} - {spreadsheetConfigurationObject.input_mapping[questionId].sheet} ! {spreadsheetConfigurationObject.input_mapping[questionId].range}</p>
              </div>
            </div>
            <div className="flex ">
              <div
                onClick={() => {
                  if (editable){
                  setSelectedQuestionId(questionId);
                  setModalOpen(true)
                  }
                }}
                className={`w-7 h-7 mr-2 ${editable ? 'cursor-pointer' : 'cursor-not-allowed'} text-gray-400`}
              >
                <PencilIcon />
              </div>
              <div
                onClick={() => {
                  if (editable)
                    updateSpreadsheetConfiguration({
                      ...spreadsheetConfigurationObject,
                      input_mapping: _.omit(spreadsheetConfigurationObject.input_mapping, questionId),
                    });
                }}
                className={`w-7 h-7 ${editable ? 'cursor-pointer' : 'cursor-not-allowed'} text-red-600`}
              >
                <TrashIcon />
              </div>
            </div>
          </div>
        );
      })}
      {editable && <Button
        onClick={() => {
          setSelectedQuestionId(null);
          setModalOpen(true)
        }}
        className="w-full"
      >
        Add mapping
      </Button>}
      {modalOpen && (
        <SpreadsheetQuestionRangeModal
          questions={questions}
          recursiveQuestions={recursiveQuestions}
          spreadsheetConfigurationObject={spreadsheetConfigurationObject}
          updateSpreadsheetConfiguration={updateSpreadsheetConfiguration}
          questionId={selectedQuestionId}
          onExit={() => {
            setModalOpen(false);
          }}
        />
      )}
    </div>
  );
}

export default ServiceConfiguratorBlockSpreadsheetInputMapping;